import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ApprovalsEquipmentsApi } from '@core/api/approvals-equipments/approvals-equipments.api';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import english from './../../i18n/en.json';
import spanish from './../../i18n/es.json';
import portuguese from './../../i18n/pt.json';
var DialogApprovalsEquipmentsApproveComponent = /** @class */ (function () {
    function DialogApprovalsEquipmentsApproveComponent(approval, matDialogRef, fuseTranslationLoaderService, approvalsEquipmentsApi, fuseProgressBarService, customMessageService, formBuilder) {
        this.approval = approval;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.approvalsEquipmentsApi = approvalsEquipmentsApi;
        this.fuseProgressBarService = fuseProgressBarService;
        this.customMessageService = customMessageService;
        this.formBuilder = formBuilder;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.approveForm = this.formBuilder.group({ message: [''] });
    }
    DialogApprovalsEquipmentsApproveComponent.prototype.acceptApproval = function () {
        var _this = this;
        this.fuseProgressBarService.show();
        this.approvalsEquipmentsApi
            .acceptEquipment(this.approval.id, this.approveForm.value.message)
            .subscribe(function (approvedApproval) {
            _this.fuseProgressBarService.hide();
            if (approvedApproval) {
                _this.customMessageService.success('APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_SUCCESSFULLY_APPROVED');
                _this.matDialogRef.close(true);
            }
        });
    };
    return DialogApprovalsEquipmentsApproveComponent;
}());
export { DialogApprovalsEquipmentsApproveComponent };
